import { ArrowUpDown } from 'lucide-react'

export function ToggleButton({ className, onClick }: { className?: string; onClick: () => void }) {
  return (
    <div className={className}>
      <button
        className="block rounded-lg border border-border bg-[#0c0c0e] p-4 text-muted-foreground transition-colors hover:bg-primary hover:text-primary-foreground"
        onClick={onClick}
      >
        <ArrowUpDown className="h-5 w-5" />
      </button>
    </div>
  )
}
